import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { AreaName } from 'domain/constants';
import { OperationType } from 'library/models/enums/OperationType';
import { createArea } from 'library/utils/helpers/AreaHelper';

import LazyRouteElement from './common/LazyRoute';
import { serviceProtocolParam } from './urls/RouteUrls';

const GenerateServiceProtocolPage = lazy(
	() => import('pages/serviceprotocol/GenerateServiceProtocolPage')
);
const ViewServiceProtocolPage = lazy(
	() => import('pages/serviceprotocol/ViewServiceProtocolPage')
);

export const getServiceProtocolRoutes = (): React.JSX.Element[] => [
	<Route
		key={'generateServiceProtocol'}
		path={`${serviceProtocolParam}?/generate`}
		element={
			<LazyRouteElement
				area={createArea(
					AreaName.ServiceProtocol,
					OperationType.Create
				)}
				Component={GenerateServiceProtocolPage}
				path={`${serviceProtocolParam}?/generate`}
			/>
		}></Route>,
	<Route
		key={'viewServiceProtocol'}
		path={`${serviceProtocolParam}/view`}
		element={
			<LazyRouteElement
				area={createArea(AreaName.ServiceProtocol, OperationType.Read)}
				Component={ViewServiceProtocolPage}
				path={`${serviceProtocolParam}/view`}
			/>
		}></Route>,
];
